var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('el-image-viewer',{attrs:{"url-list":_vm.urlList,"initial-index":_vm.initialIndex,"z-index":_vm.zIndex,"on-close":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }